import AppConstants from '../config/app.constants';

let LanguageService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/language`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/language`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/language/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/language/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/language/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let getAllUIMessages = (key) => {
        return $http
            .get(`${AppConstants.api}/language/ui-messages?key=${key}`)
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        create,
        remove,
        update,
        get,
        getAllUIMessages
    };
};

LanguageService.$inject = ['$http', '$q']

export default LanguageService;


// WEBPACK FOOTER //
// ./client/app/services/language.service.js